const POLLING_INTERVALS = {
  VERY_SHORT: 1000,
  SHORT: 1500,
  MEDIUM: 3000,
} as const;

export default POLLING_INTERVALS;
